import { ConnectButton } from "@rainbow-me/rainbowkit"
import { useLocation, useNavigate } from "react-router-dom"
import { Logo } from "../assets"
import { Button } from "./commons"
import { siteMap } from "./commons/constants"

const NavBar = () => {
  const history = useNavigate()
  const location = useLocation()
  const isDefaultPath = Object.values(siteMap).find((site) => site.path === location.pathname)?.path ?? '/'

  const navigateTo = (route: string) => {
    history(route)
  }

  return (
    <div style={{
      display: 'grid', color: 'white',
      padding: '1rem 2rem', gridTemplateColumns: 'fit-content(100%) 5fr 2fr',
      alignItems: 'center',
      marginBottom: '4rem',
      gap: '2rem',
    }}>
      <div>
        <Logo style={{ maxWidth: '11rem', cursor: 'pointer' }} onClick={() => navigateTo('/')} />
      </div>
      <div style={{ display: 'flex', gap: '1rem' }}>
        {
          Object.values(siteMap).filter((sites) => sites.display).map(({ path, name }) => {
            return (
              <Button key={name} onClick={() => navigateTo(path)} size='large' variant='text' isSelected={location.pathname === path || isDefaultPath === path} sx={{ border: 0 }}>
                {name}
              </Button>
            )
          })
        }
      </div>
      <div className="rainbowConnectButton" style={{ display: 'flex', gap: '1rem', justifySelf: 'flex-end', alignSelf: 'center' }}>
        <ConnectButton label="Connect" />
      </div>
    </div>
  )
}

export default NavBar